import React from 'react';
import { Route, BrowserRouter as Router, Redirect } from 'react-router-dom';
import { Provider, useSelector } from 'react-redux';
import './assets/scss/index.scss';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import LoginPage from './pages/auth/Login';
import SignupPage from './pages/auth/Signup';
import ForgotPasswordPage from './pages/auth/ForgotPassword';
import DashboardPage from './pages/dashboard';
import UsersPage from './pages/users';

import { AuthProvider } from './contexts/AuthContext';

import configureStore from './store';
const store = configureStore({});

const App = () => {
  return (
    <Provider store={store}>
      <AuthProvider>
        <Router>
          <div className="App">
            <Route exact path="/" component={LoginPage} />
            <Route exact path="/signup" component={SignupPage} />
            <Route exact path="/forgot-password" component={ForgotPasswordPage} />
            <Route exact path="/dashboard" component={DashboardPage} />
            <Route exact path="/admin/users" component={UsersPage} />
            <NotificationContainer />
          </div>
        </Router>
      </AuthProvider>
    </Provider>
  );
};

export default App;
